import { styles } from "@/config/project";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Box, Divider, IconButton, Stack, Typography } from "@mui/material";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { ToolbarProps, ToolbarSlot } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { RenderGoToPageProps } from "@react-pdf-viewer/page-navigation";
import {
    RenderCurrentScaleProps,
    RenderZoomOutProps,
} from "@react-pdf-viewer/zoom";
import { ChevronDown, ChevronUp } from "lucide-react";
import { ReactElement } from "react";

export const ViewerToolbar = (
    Toolbar: (props: ToolbarProps) => ReactElement
) => (
    <Toolbar>
        {(slots: ToolbarSlot) => {
            const {
                CurrentPageInput,
                CurrentScale,
                GoToNextPage,
                GoToPreviousPage,
                NumberOfPages,
                ZoomIn,
                ZoomOut,
            } = slots;
            return (
                <div
                    style={{
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        width: "100%",
                        height: "100%",
                        backgroundColor: styles.buttonDark,
                    }}
                >
                    <Stack
                        direction={"row"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        spacing={1}
                    >
                        <GoToPreviousPage>
                            {(props: RenderGoToPageProps) => (
                                <IconButton
                                    onClick={props.onClick}
                                    size="small"
                                    disabled={props.isDisabled}
                                >
                                    {props.isDisabled ? (
                                        <ChevronUp size={20} color="gray" />
                                    ) : (
                                        <ChevronUp size={20} color="white" />
                                    )}
                                </IconButton>
                            )}
                        </GoToPreviousPage>
                        <CurrentPageInput />
                        <Typography variant="body2" color="white">
                            / <NumberOfPages />
                        </Typography>
                        <GoToNextPage>
                            {(props: RenderGoToPageProps) => (
                                <IconButton
                                    onClick={props.onClick}
                                    size="small"
                                    disabled={props.isDisabled}
                                >
                                    {props.isDisabled ? (
                                        <ChevronDown size={20} color="gray" />
                                    ) : (
                                        <ChevronDown size={20} color="white" />
                                    )}
                                </IconButton>
                            )}
                        </GoToNextPage>
                    </Stack>
                    <Divider
                        orientation="vertical"
                        flexItem
                        sx={{ bgcolor: "#BDBDC7", my: 1.25, mx: 2 }}
                    />
                    <Stack
                        direction={"row"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        spacing={1}
                    >
                        <ZoomOut>
                            {(props: RenderZoomOutProps) => (
                                <IconButton
                                    onClick={props.onClick}
                                    size="small"
                                >
                                    <RemoveIcon
                                        sx={{ color: "white" }}
                                        fontSize="small"
                                    />
                                </IconButton>
                            )}
                        </ZoomOut>
                        <CurrentScale>
                            {(props: RenderCurrentScaleProps) => (
                                <Box bgcolor={"#191B1C"} color={"white"} px={1}>
                                    <Typography variant="body2">
                                        {Math.round(props.scale * 100)}
                                    </Typography>
                                </Box>
                            )}
                        </CurrentScale>
                        <ZoomIn>
                            {(props: RenderZoomOutProps) => (
                                <IconButton
                                    onClick={props.onClick}
                                    size="small"
                                >
                                    <AddIcon
                                        sx={{ color: "white" }}
                                        fontSize="small"
                                    />
                                </IconButton>
                            )}
                        </ZoomIn>
                    </Stack>
                </div>
            );
        }}
    </Toolbar>
);
